export default __webpack_public_path__ + "static/media/gym-img-09.5ce020f6.jpg";